import React from 'react';
import '../ComponentsCSS/Footer.css';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="footer mt-5 pt-5">
      <div className="container">
        <div className="row justify-content-between gx-5">

          {/* Logo & Newsletter */}
          <div className="col-lg-4 col-md-4 col-sm-12 footer-logo mb-4">
            <div className="logo mb-2">
              <Link to="/" className='head'>
                <img className='img-fluid' src="./assets/logo.png" alt="" /> SASK A One  Shuttle
              </Link>
            </div>
            <p>
              At SASK A One Shuttle, whether you're a startup, a growing business, or an enterprise, we deliver smart, scalable, and seamless logistics solutions built for speed, reliability, and customer satisfaction.
            </p>
            <h2>Newsletter</h2>
            <div className="input-group mb-3">
              <input type="email" className="form-control" plSASK holder="Email" />
              <button className="btn btn-submit" type="button">Submit</button>
            </div>
          </div>

          {/* Info Links */}
          <div className="col-lg-4 col-md-4 col-sm-12 footer-section mb-4 text-center">
            <h1>Info</h1>
            <Link to="/">Home</Link>
            <Link to="/about">About Us</Link>
            <Link to="/services">Services</Link>
          </div>

          {/* Contact Info */}
          <div className="col-lg-4 col-md-4 col-sm-12 footer-section contact-info mb-4">
            <h1>Contact Info</h1>
            <p><i className="fa fa-map-marker"></i> #2-75 South Industrial Drive,
Prince Albert, SK. S6V 7L7, Ca</p>
            <p><i className="fa fa-envelope"></i> admin@saskaoneshuttle.com</p>
            <p>
  <i className="fa fa-phone"></i> 
  <a href="tel:+16394702917"> +1 (639) 470-2917</a>
</p>
<p>
  <i className="fa fa-phone"></i> 
  <a href="tel:+13064916375"> +1 (306) 491-6375</a>
</p>
            <p><i className="fa fa-fax"></i> 1 306-500-9618</p>
          </div>

        </div>

        <div className="text-center mt-4 footer-bottom">
          © 2025 SASK A One Shuttle. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
